<template>
  <div>
    <div class="d-flex mb-3">
      <h3>Internal Note</h3>
    </div>

    <div class="d-flex mb-2 align-middle row">
      <div class="d-flex col-12 col-sm-8 col-md-8">
        <div class="col-5 pl-0">
          <button
            class="btn btn-custome-rounded btn-blue pl-2 pr-2 text-dark"
            @click="isAddNote = true"
            v-if="!isAddNote">
            <b>+ADD A NOTE</b>
          </button>
          <button
            class="btn btn-custome-rounded btn-round-green pl-2 pr-2 text-dark"
            @click="saveNewNote()"
            v-if="isAddNote">
            <b>SAVE NOTE</b>
          </button>
        </div>
        <div class="col-4" />
        <div class="col-2 pl-0">
          <button
            class="btn btn-custome-rounded btn-red pl-2 pr-2 text-dark"
            @click="cancelAddANote()"
            v-if="isAddNote">
            <b>CANCEL</b>
          </button>
        </div>
      </div>
    </div>

    <div class="d-flex mb-2 align-middle row">
      <div class="col-12 col-sm-8 col-md-8">
        <div class="mb-3">
          <input
            type="text"
            class="form-control"
            placeholder="Please add your note."
            v-model="manualNote"
            :disabled="!isAddNote"
          />
        </div>
      </div>

      <div
        class="col-12 col-sm-8 col-md-8"
        v-for="(item, index) in detailNoteList"
        :key="index"
      >
        <div class="mb-1" v-if="item.type == 'MANUAL'">
          {{ item.content }}
        </div>
        <div class="mb-1" v-else>{{ item.content }} - {{ item.type }}</div>

        <div v-if="item.content && item.user" class="mb-3" style="font-size: 11px">
          Date: {{ formatDate(item.created) }} + {{ item.user }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { AXIOS } from '../../scripts/http-common';
import moment from 'moment';

export default {
    name: 'NotesManager',
    props: ["notesHolder", "holderType"],
    components: {
    },
    data() {
      return {
        isAddNote: false,
        manualNote: "",
      }
    },
    computed: {
      detailNoteList() {
        return this.generateNoteLists(this.notesHolder.notes);
      }
    },
    mounted() {
      let userInStorage = JSON.parse(localStorage.getItem("loggedUser"));
      this.loggedInUser =
        this.$store.getters.getUser != ""
          ? this.$store.getters.getUser
          : userInStorage
          ? userInStorage
          : "";

      this.generateNoteLists(this.notesHolder.notes);
    },
    methods: {
      generateNoteLists(noteList) {
        let detailNoteList = [];
        if (noteList != null) {
          let notes = noteList.split("###");

          for (let i = 0; i < notes.length; i++) {
            let items = notes[i].split("=*=");

            if (items.length == 4) {
              detailNoteList.push({
                type: items[0],
                content: items[1],
                user: items[2].toUpperCase(),
                created: items[3],
              });
            }
            if (items.length == 1) {
              detailNoteList.push({
                type: "MANUAL",
                content: items[0],
                user: null,
                created: null,
              });
            }
          }
        }
        const firstArray = detailNoteList.filter(
          (x) => x.created == null || x.created == undefined
        );
        let secondArray = detailNoteList.filter(
          (x) => x.created !== null && x.created !== undefined
        );
        secondArray.sort((a, b) => {
          const fistValue = moment(a.created, "DD/MM/YYYY hh:mm:ss A").valueOf();
          const secondValue = moment(b.created, "DD/MM/YYYY hh:mm:ss A").valueOf();
          return secondValue - fistValue;
        });
        detailNoteList = firstArray.concat(secondArray);
        return detailNoteList;
      },
      formatDate(date) {
        const dateInNY = moment.tz(date, "DD/MM/YYYY hh:mm:ss A", "America/New_York");
        const utcTime = dateInNY.toDate();
        const localTime = moment.utc(utcTime).local().format("MM/DD/YYYY hh:mm A");
        return localTime;

        // return moment(date,"DD/MM/YYYY hh:mm:ss A").format('MM/DD/YYYY hh:mm A');
      },
      saveNewNote() {
        this.isAddNote = false;
        let self = this;
        let isOrder = 'submission' != this.holderType;
        let updateNotesURI = isOrder ? `/admin/order/id/${this.$route.params.id}/update-notes`
          : `/admin/efile/submission/id/${this.$route.params.id}/update-notes`;
        AXIOS.put(updateNotesURI, {
          orderNum: this.$route.params.id,
          content: this.manualNote,
          type: "MANUAL",
          user: self.loggedInUser.username,
        })
          .then((response) => {
            this.manualNote = "";
            this.$emit('onUpdate');
          })
          .catch((e) => {
            this.$router.push("/login");
          });
      },
      cancelAddANote() {
        this.manualNote = "";
        this.isAddNote = false;
      },

    }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/common/NotesManager.vue